import React from 'react';

import { existy } from 'utils/functional';

import { LetsMeetCardProps, LetsMeetCard } from 'components/lets-meet/LetsMeetCard';
import { ExpertiseHighlightProps, ExpertiseHighlight } from 'components/expertise/ExpertiseHighlight';
import { WebImage } from 'components/common/WebImage';
import { ThumbnailImage } from './atoms/ThumbnailImage';
import { ImageWrapper } from './atoms/ImageWrapper';
import { Wrapper } from './atoms/Wrapper';
import { LetsMeetWrapper } from './atoms/LetsMeetWrapper';
import { HighlightWrapper } from './atoms/HighlightWrapper';

interface Props {
    letsMeet: LetsMeetCardProps;
    highlight: ExpertiseHighlightProps;
    image?: any;
    meetRight?: boolean;
    offsetMeet?: boolean;
    type?: string;
}

export const MeetTheExpertise: React.FC<Props> = ({
    highlight,
    letsMeet,
    image,
    type,
    meetRight = false,
    offsetMeet = false,
}) => {
    const hasImage = existy(image);
    const renderImage = (): JSX.Element => {
        if (hasImage) {
            return (
                <ImageWrapper offsetMeet={offsetMeet} meetRight={meetRight} hasImage={hasImage}>
                    <ThumbnailImage>
                        <WebImage
                            image={{
                                alt: highlight.title,
                                ...image,
                            }}
                        />
                    </ThumbnailImage>
                </ImageWrapper>
            );
        }
    };

    return (
        <Wrapper offsetMeet={offsetMeet} meetRight={meetRight} hasImage={hasImage}>
            {renderImage()}
            <LetsMeetWrapper offsetMeet={offsetMeet} meetRight={meetRight} hasImage={hasImage}>
                <LetsMeetCard {...letsMeet} />
            </LetsMeetWrapper>
            <HighlightWrapper offsetMeet={offsetMeet} meetRight={meetRight} hasImage={hasImage}>
                <ExpertiseHighlight
                    type={type}
                    isPurple={meetRight}
                    extraPaddingLeft={!meetRight && hasImage}
                    extraPaddingRight={meetRight && hasImage}
                    {...highlight}
                />
            </HighlightWrapper>
        </Wrapper>
    );
};
